import { useEffect, useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';

/* JS */
import * as Server from 'assets/js/Server';

/* Chart */
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

export default function MainPage() {
  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
    }),
    []
  );

  const [headquarter, setHeadquarter] = useState({
    clientName: '',
    contractStartDt: '',
    contractEndDt: '',
    workCnt: '',
    todaySchedule: '',
    checkInSchedule: '',
  });
  const [customer, setCustomer] = useState([{
    clientName: '',
    contractStartDt: '',
    contractEndDt: '',
    workCnt: '',
    todaySchedule: '',
    checkInSchedule: '',
    config: {
      labels: [],
      datasets: [],
    },
    captureList: {
      cockroachesList: [],
      houseFliesList: [],
      lizardsList: [],
      otherInsectsList: [],
      rodentsList: [],
    },
  }]);

  const generateDataset = useCallback((label, data) => ({
    label,
    data,
    borderColor: [
      'rgba(255, 99, 132, 1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
    ],
    borderWidth: 1,
  }), []);

  //Effect
  useEffect(() => {
    getMainPageData();
  }, []);

  //Function
  const getMainPageData = () => {
    Server.sendGet('client/main', {}, getMainPageDataCallback).then();
  };

  const getMainPageDataCallback = res => {
    const resultList = res?.['resultList'] || [];

    if (resultList.length > 0) {
      const customerList = resultList.map(obj => {
        if (obj.custMstSeq === '20') {
          setHeadquarter(obj);

          return null;
        }

        const config = {
          labels: obj.captureList.cockroachesList.map(item => item.regDate),
          datasets: [
            generateDataset('cockroaches', obj.captureList.cockroachesList.map(item => item.pestsCnt)),
            generateDataset('houseFlies', obj.captureList.houseFliesList.map(item => item.pestsCnt)),
            generateDataset('lizards', obj.captureList.lizardsList.map(item => item.pestsCnt)),
            generateDataset('otherInsects', obj.captureList.otherInsectsList.map(item => item.pestsCnt)),
            generateDataset('rodents', obj.captureList.rodentsList.map(item => item.pestsCnt)),
          ],
        };

        return { ...obj, config };
      }).filter(Boolean);

      setCustomer(customerList);
    }
  };

  return (
    <MainWrap>
      <div className='content-inner'>
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Home</h4>
          </div>
        </div>

        <div className='content'>
          <div className='home-inner'>
            <div className='head-quarter chart-desc'>
              <h4>Headquarter</h4>
              <ul className='user-list'>
                <li className='user-item'>
                  <div className='client-head'>
                    <strong>{headquarter?.clientName}</strong>
                  </div>
                  <div className='client-con'>
                    <ul className='client-info'>
                      <li>
                        <span className='tit'>Contract Start Date</span>
                        <p className='value'>{headquarter?.contractStartDt}</p>
                      </li>
                      <li>
                        <span className='tit'>Contract End Date</span>
                        <p className='value'>{headquarter?.contractEndDt}</p>
                      </li>
                      <li>
                        <span className='tit'>Number of Worker</span>
                        <p className='value'>{headquarter?.workCnt}</p>
                      </li>
                      <li>
                        <span className='tit'>Today Schedule</span>
                        <p className='value'>{headquarter?.checkInSchedule ? headquarter?.checkInSchedule : 0} / {headquarter?.checkInSchedule ? headquarter?.checkInSchedule : 0}</p>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

            <div className='customer chart-desc'>
              <h4>Customer</h4>
              <ul className='user-list'>
                {customer.map(item => (
                  <li className='user-item' key={item.custMstSeq}>
                    <div className='client-head'>
                      <strong>{item.clientName}</strong>
                    </div>
                    <div className='client-con'>
                      <ul className='client-info'>
                        <li>
                          <span className='tit'>Contract Start Date</span>
                          <p className='value'>{item?.contractStartDt}</p>
                        </li>
                        <li>
                          <span className='tit'>Contract End Date</span>
                          <p className='value'>{item?.contractEndDt}</p>
                        </li>
                        <li>
                          <span className='tit'>Number of Worker</span>
                          <p className='value'>{item?.workCnt}</p>
                        </li>
                        <li>
                          <span className='tit'>Today Schedule</span>
                          <p className='value'>{item?.checkInSchedule ? item?.checkInSchedule : 0} / {item?.todaySchedule ? item?.todaySchedule : 0}</p>
                        </li>
                      </ul>
                      <div className='client-chart' style={{ width: '100%' }}>
                        <strong>Monthly Trend</strong>
                        <Line data={item?.config} option={options} redraw={true}/>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </MainWrap>
  )
}

const MainWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(100% - 280px);
  background: #ffffff;
  height: 830px;

  .content-inner {
    position: relative;
    height: 100%;

    .content {
      height: calc(100% - 75px);

      .home-inner {
        position: relative;
        overflow-y: auto;

        .chart-desc {

          &.customer {
            margin-top: 30px;
          }

          h4 {
            font-weight: 700;
            font-size: 24px;
            color: #111111;
          }

          .user-list {
            margin-top: 25px;
            position: relative;
            width: 100%;
            display: flex;
            gap: 20px 20px;
            flex-wrap: wrap;

            .user-item {
              width: calc(33.33% - 13.33px) !important;
              border: 1px solid #dddddd;
              overflow: hidden;
            }
          }

          .client-head {
            position: relative;
            padding: 20px 10px;
            border-bottom: 1px solid #dddddd;

            strong {
              font-weight: 600;
              font-size: 16px;
              color: #111111;
            }
          }

          .client-con {
            position: relative;
            padding: 20px 10px;
            display: flex;
            flex-direction: column;
            gap: 20px 0;

            .client-info {
              li {

                & + li {
                  margin-top: 12px;
                }

                display: flex;
                align-items: center;
                gap: 0 16px;

                span {
                  flex: 1;
                  font-weight: 500;
                  font-size: 14px;
                  color: #111111;
                  text-align: left;
                }

                p {
                  flex: 1;
                  font-weight: 500;
                  font-size: 14px;
                  color: #111111;
                  text-align: right;
                }
              }
            }

            .client-chart {
              margin-top: 25px;
              width: 100%;
              max-width: 100%;
              overflow: hidden;

              strong {
                font-weight: 600;
                font-size: 16px;
                color: #111111;
              }
            }
          }
        }
      }
    }
  }

  * {
    font-family: 'Apple SD Gothic Neo', sans-serif;
  }
`;